import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddNewService from "../../components/admincomponents/AddNewService";

function AddService({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddNewService />            
    </>
  );
}

export default AddService;
